
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/homeowners-resource-guide-to-gardening",
      function () {
        return require("private-next-pages/articles/homeowners-resource-guide-to-gardening.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/homeowners-resource-guide-to-gardening"])
      });
    }
  